import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'rcp-oup-worklist-issues',
    templateUrl: './worklist-issues.component.html',
    styleUrls: ['./worklist-issues.component.scss'],
    standalone: false,
})
export class WorklistIssuesComponent implements OnInit {
    isAllWorklistHovered: boolean = false;
    isNotificationsHovered: boolean = false;
    isToDoHovered: boolean = false;
    constructor() {}

    ngOnInit(): void {}
}
